import * as notificationsTypes from "../../types/admin/notificationTypes";

export const NotificationUpdateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case notificationsTypes.UPDATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        notifyUpdateLoading: true,
      };
    case notificationsTypes.UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifyUpdateLoading: false,
        notifyUpdateInfo: payload,
        notifyUpdateErrors: "",
      };
    case notificationsTypes.UPDATE_NOTIFICATION_FAIL:
      return {
        ...state,
        notifyUpdateLoading: false,
        notifyUpdateErrors: payload,
        notifyUpdateInfo: [],
      };
    default:
      return state;
  }
};

export const NotificationGetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case notificationsTypes.GET_NOTIFICATION_REQUEST:
      return {
        ...state,
        notifyLoading: true,
      };
    case notificationsTypes.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifyLoading: false,
        notifyInfo: payload,
        notifyErrors: "",
      };
    case notificationsTypes.GET_NOTIFICATION_FAIL:
      return {
        ...state,
        notifyLoading: false,
        notifyErrors: payload,
        notifyInfo: [],
      };
    case notificationsTypes.ADD_NOTIFICATION:
      return {
        ...state,
        notifyInfo: [...(state.notifyInfo || []), action.payload],
      };
    default:
      return state;
  }
};
